module.exports = __webpack_public_path__ + "static/media/f7bb9f98-a5c9-471c-8794-7f664e1708fe.b15a254d.jpg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/chicago-council-headshots/dist/img/headshots/f7bb9f98-a5c9-471c-8794-7f664e1708fe.jpg
// module id = 868
// module chunks = 0